export type AppType = 'sushi' | 'catering'

export const getAppType = (): AppType => {
  const path = window.location.pathname
  if (path.startsWith('/catering')) return 'catering'
  return 'sushi'
}

export const getStorageKey = (key: string): string => {
  if (key === 'language') return key
  return `${getAppType()}_${key}`
}
